'use client';

import { useRouter } from 'next/navigation';
import { FeatherChevronLeft } from '@subframe/core';
import React from 'react';
import { Button } from './Button';

interface BackButtonProps {
  previousHref?: string;
  disabled?: boolean;
  className?: string;
  label?: string;
}

export function BackButton({
  previousHref,
  disabled = false,
  className,
  label = 'Voltar',
}: BackButtonProps) {
  const router = useRouter();

  const handleClick = () => {
    if (disabled) return;
    const canGoBack = typeof window !== 'undefined' && window.history.length > 1;
    if (canGoBack) {
      router.back();
      return;
    }
    if (previousHref) {
      router.push(previousHref);
      return;
    }
  };

  return (
    <Button
      variant="neutral-secondary"
      size="small"
      icon={<FeatherChevronLeft />}
      onClick={handleClick}
      disabled={disabled}
      aria-label={label}
      className={className}
    >
      {label}
    </Button>
  );
}
